module.exports = __webpack_public_path__ + "static/media/star.f5d1deee.svg";